@if ({ initialData: initialData$ | async, context: context$ | async }; as data) {
  <div class="search-widget">
    <div name="searchform" class="searchbox am-ctn am-ctn--gtr">
      <div class="am-ctn am-ctn--xxl am-ctn--gtr">
        <am-search-box [ngClass]="{ 'hide-autocomplete': isLanding$ | async }" [country]="data.context?.site"
          [brand]="data.context?.brand" [channel]="data.context?.channel" [initialData]="data.initialData"
          [product]="'hotels'" [dataType]="'model'" [allowDollar]="data.context?.allowDollar" [disableARS]="data.context?.disableARS"
          (modelSearch)="handleSearch($event)">
        </am-search-box>
      </div>
    </div>
  </div>
}